/*
  +--------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     账户管理-用户 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApi = process.env.VUE_APP_GENERAL_API_HOST;

export function getUserInfoApi(params) {
  return request({
    url: generalApi + '/fam/get',
    method: 'get',
    params
  })
}

export function postUserInfoApi(formData) {
  return request({
    url: '?c=fam&a=user&do=post',
    method: 'post',
    data: formData
  })
}
